// CreaMenu.js
import React, { Component } from 'react';
import FasceOrarie from './FasceOrarie';
import ComponentList from './ComponentLista';
import CampiMenu from './CampiMenu';
import "./CreaEvento.css";

class CreaMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: CreaMenu.initializeFormData(props.evento, props.azienda),
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.evento !== prevState.prevEventoProp) {
      return {
        prevEventoProp: nextProps.evento,
        formData: CreaMenu.initializeFormData(nextProps.evento, nextProps.azienda),
      };
    }
    return null;
  }

  static initializeFormData(evento, aziendaId) {
    return {
      titolo: evento?.titolo || '',
      descrizione: evento?.descrizione || '',
      dataInizio: evento?.dataInizio ? evento.dataInizio.substring(0, 16) : '',
      dataFine: evento?.dataFine ? evento.dataFine.substring(0, 16) : '',
      prezzo: evento?.prezzo || 0,
      immagineCopertina: null,
      fileName: evento?.copertinaName || null,
      campiMenu: evento?.portate || [],
      categorie: evento?.categorie || [],
      fasceOrarie: evento?.fasceOrarie || [],
      idAzienda: evento?.idAzienda || aziendaId,
      posti: evento?.posti|| 0
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onFormSubmit(this.state.formData);
    // La logica di reset del form dovrebbe essere gestita nel componente genitore se necessario
  };

  handleFasceOrarieChange = (fasceOrarie) => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        fasceOrarie,
      },
    }));
  };

  handleCampiMenuChange = (campiMenu) => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        campiMenu,
      },
    }));
  };

  handleSelectedData = (selectedData) => {
    const categorieIds = Array.isArray(selectedData) ? selectedData : [selectedData];
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        categorie: categorieIds,
      },
    }));
    console.log('Dati selezionati:', selectedData);
  };

  handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === 'file') {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState((prevState) => ({
          formData: {
            ...prevState.formData,
            immagineCopertina: reader.result,
            fileName: files[0].name,
          },
        }));
      };
      reader.readAsDataURL(files[0]);
    } else {
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          [name]: value,
        },
      }));
    }
  };

  render() {
    const { formData } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <label>
          Titolo:
          <input type="text" name="titolo" value={formData.titolo} onChange={this.handleChange} />
        </label>
        <br />
        <label>
          Descrizione:
          <input type="text" name="descrizione" value={formData.descrizione} onChange={this.handleChange} />
        </label>
        <br />
        <label>
          Data di Inizio:
          <input
            type="date"
            name="dataInizio"
            value={formData.dataInizio}
            onChange={this.handleChange}
          />
        </label>
        <br />
        <label>
          Data di Fine:
          <input
            type="date"
            name="dataFine"
            value={formData.dataFine}
            onChange={this.handleChange}
          />
          <FasceOrarie onFasceOrarieChange={this.handleFasceOrarieChange} initialFasceOrarie={formData.fasceOrarie} />
          <br />
        </label>
        <br />
        <label>
          Prezzo:
          <input type="number" name="prezzo" value={formData.prezzo} onChange={this.handleChange} />
        </label>

        <label>
          Posti disponibili:
          <input type="number" name="posti" value={formData.posti} onChange={this.handleChange} />
        </label>
        <br />
        <label>
          Immagine di Copertina:
          <input type="file" name="immagineCopertina" onChange={this.handleChange} />
          {formData.fileName && <p>File selezionato: {formData.fileName}</p>}
          {formData.immagineCopertina && <img src={formData.immagineCopertina} alt="Copertina" style={{ maxWidth: '100px' }} />}
        </label>
        <br />
        <ComponentList onSelectedData={this.handleSelectedData} initialCategories={formData.categorie} />
        <br />
        <label> Lista portate <hr /><CampiMenu onCampiChange={this.handleCampiMenuChange} initialCampi={formData.campiMenu} /></label>
        <button type="submit">Invia</button>
      </form>
    );
  }
}

export default CreaMenu;